import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import Logo from './Logo';
import { STEPS, brandPanelGradient, ON_DARK } from '../Pages/Landing/constants';
import {
	EmailMockup,
	InvoiceEmailMockup,
} from '../Pages/Landing/ProductMockups';

const AuthProductPanel = () => {
	return (
		<Box
			sx={{
				display: { xs: 'none', lg: 'flex' },
				flexDirection: 'column',
				width: { lg: '44%' },
				flexShrink: 0,
				height: { lg: '100vh' },
				position: { lg: 'sticky' },
				top: 0,
				overflow: 'auto',
				background: (theme) => brandPanelGradient(theme.palette.mode),
				color: ON_DARK.text,
				py: { lg: 5 },
				px: { lg: 4, xl: 6 },
			}}
		>
			<Container maxWidth="sm" disableGutters>
				<Logo variant="onDark" sx={{ width: 140, height: 'auto', mb: 4 }} />
				<Typography
					variant="h4"
					sx={{ fontWeight: 700, mb: 2, lineHeight: 1.25, color: ON_DARK.text }}
				>
					Send the proposal. Bidzbase follows up until they say yes or no.
				</Typography>
				<Typography
					sx={{
						color: ON_DARK.muted,
						mb: 4,
						lineHeight: 1.75,
						maxWidth: 420,
					}}
				>
					One-click accept in the email. Automatic reminders on open bids and
					unpaid invoices. Deposit when they say yes.
				</Typography>

				<Stack spacing={2.5} sx={{ mb: 4 }}>
					{STEPS.map((step) => (
						<Stack
							key={step.step}
							direction="row"
							spacing={2}
							alignItems="flex-start"
						>
							<Typography
								variant="overline"
								sx={{
									color: 'warning.main',
									fontWeight: 800,
									minWidth: 28,
									pt: 0.25,
								}}
							>
								{step.step}
							</Typography>
							<Box>
								<Typography
									variant="subtitle2"
									sx={{ fontWeight: 700, color: ON_DARK.text }}
								>
									{step.title}
								</Typography>
								<Typography
									variant="body2"
									sx={{
										color: ON_DARK.soft,
										mt: 0.25,
										lineHeight: 1.6,
									}}
								>
									{step.description}
								</Typography>
							</Box>
						</Stack>
					))}
				</Stack>

				<Typography
					variant="overline"
					sx={{
						color: 'warning.main',
						fontWeight: 700,
						letterSpacing: '0.12em',
						display: 'block',
						mb: 2,
					}}
				>
					What your customers see
				</Typography>
				<Grid container spacing={2}>
					<Grid size={{ xs: 12 }}>
						<EmailMockup />
					</Grid>
					<Grid size={{ xs: 12 }}>
						<InvoiceEmailMockup />
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
};

export default AuthProductPanel;
